import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

export const useUserCommericalHooks = () => {
  //all local states
  const [allCommercialData, setAllCommercialData] = useState([]);

  //all redux
  const user_commercial_redux = useSelector(
    (s) => s?.allUserCommercialData ?? []
  );

  //all useEffect
  useEffect(() => {
    if (user_commercial_redux?.length > 0) {
      setAllCommercialData(user_commercial_redux);
    }
  }, [user_commercial_redux]);
  console.log({ user_commercial_redux });

  return {
    //all local states
    allCommercialData,
  };
};
